import React, { useState } from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import Responsive from '../../assets/config/Responsive'
import EnvelopeClosedIcon from '../../assets/icons/JSX/EnvelopeClosedIcon'
import FilterIcon from '../../assets/icons/JSX/FilterIcon'
import RedDot from '../../assets/icons/JSX/RedDot'
import TrashIcon from '../../assets/icons/JSX/TrashIcon'
import Colors from '../../assets/styles/Colors'
import Dropdown from '../../components/Dropdown'
import api from '../../api'
import Loader from '../../components/Loader'

const NotificationList: React.FC = () => {
  // for filter
  const [showFilters, setShowFilters] = useState<boolean>(false)
  // navigate
  const navigate = useNavigate()

  const { data: notificationListArr, isFetching: isNotificationListLoading } =
    api.useGetNotificationListQuery(undefined)

  const FakeData = [{}, {}]
  return isNotificationListLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Filter>
        <ScreenTitle>Notifications</ScreenTitle>
        <button onClick={() => setShowFilters(!showFilters)}>
          Filter
          <FilterIcon />
        </button>
      </Filter>
      {showFilters ? (
        <DropdownWrapper>
          <Dropdown
            title={'Category'}
            data={['Car', 'Car']}
            placeholder={'Car'}
            onChange={(value) => console.log(value)}
          />

          <Dropdown
            title={'Company'}
            data={['GPI holding', 'GPI holding', 'GPI holding']}
            placeholder={'GPI holding'}
            onChange={(value) => console.log(value)}
          />

          <Dropdown
            title={'Insured'}
            data={['BA754IK', 'BA754IK']}
            placeholder={'BA754IK'}
            onChange={(value) => console.log(value)}
          />

          <Dropdown
            title={'Status'}
            data={['All status', 'All status']}
            placeholder={'All status'}
            onChange={(value) => console.log(value)}
          />
        </DropdownWrapper>
      ) : null}
      <NotificationWrapper>
        <TitleSection>
          <Title>Title</Title>
          <Title>Notification text</Title>
          <Title>Date</Title>
          <Title>Actions</Title>
        </TitleSection>
        {FakeData.map((item, index) => {
          return !notificationListArr ? (
            <div>
              <Transaction onClick={() => navigate('/notification-details')}>
                <IconWrapper />
                <NotificationTitleItem>
                  <RedDotStyle />
                  Lorem ipsum is dummy Text
                </NotificationTitleItem>
                <NotificationDateItemMobile>23 Oct 2022</NotificationDateItemMobile>
                <NotificationTextItem>
                  Lorem ipsum is dummy TextLorem ipsum is dummy TextLorem ipsum is dummy TextLorem ipsum is dummy Text
                </NotificationTextItem>
                <NotificationDateItem>23 Oct 2022</NotificationDateItem>
                <NotificationIconItem>
                  <EnvelopeClosedIconStyle />
                  <TrashIconStyle />
                </NotificationIconItem>
              </Transaction>
              <HorizontalLine />
            </div>
          ) : null
        })}
        {notificationListArr?.map((item, index) => {
          return !notificationListArr ? (
            <div key={index}>
              <Transaction onClick={() => navigate('/notification')}>
                <IconWrapper />
                <NotificationTitleItem>
                  <RedDotStyle />
                  {item.title}
                </NotificationTitleItem>
                <NotificationTextItem>{item.message}</NotificationTextItem>
                <NotificationDateItem>23 Oct 2022</NotificationDateItem>
                <NotificationIconItem>
                  <EnvelopeClosedIconStyle />
                  <TrashIconStyle />
                </NotificationIconItem>
              </Transaction>
              <HorizontalLine />
            </div>
          ) : null
        })}
      </NotificationWrapper>
    </Wrapper>
  )
}
//
//
const IconWrapper = styled.div``
const NotificationWrapper = styled.div`
  border-radius: 10px;
  /* padding: 45px 70px 55px 70px; */
  -webkit-box-shadow: 0px 0px 15px 3px #88888811;
  box-shadow: 0px 0px 15px 3px #88888811;
  background-color: ${Colors.white};
  border-radius: 8px;
  ${Responsive.mobile} {
    padding: 10px 20px 35px 20px;
  }
`
const Transaction = styled.div`
  padding: 20px 60px;
  display: flex;
  cursor: pointer;
  ${Responsive.mobile} {
    display: block;
    padding: 30px 30px;
  }
`
const NotificationTitleItem = styled.div`
  font-size: 16px;
  margin-top: 4px;
  margin-bottom: 4px;
  margin-left: 30px;
  width: 20%;
  ${Responsive.mobile} {
    margin-left: 0px;
    width: 100%;
  }
`
const NotificationTextItem = styled.div`
  font-size: 16px;
  margin-top: 4px;
  margin-bottom: 4px;
  margin-left: 90px;
  width: 40%;
  ${Responsive.mobile} {
    color: ${Colors.primaryGrey};
    margin-left: 0px;
    margin-top: 15px;
    width: 100%;
  }
`
const NotificationDateItem = styled.div`
  font-size: 16px;
  margin-top: 4px;
  margin-bottom: 4px;
  margin-left: 30px;
  width: 20%;
  ${Responsive.mobile} {
    display: none;
  }
`
const NotificationDateItemMobile = styled(NotificationDateItem)`
  display: none;
  ${Responsive.mobile} {
    display: block;
    color: ${Colors.primaryGrey};
    margin-left: 0px;
    width: 100%;
  }
`
const NotificationIconItem = styled.div`
  margin-top: 4px;
  margin-bottom: 4px;
  margin-left: 30px;
  width: 20%;
  gap: 20px;
  ${Responsive.mobile} {
    display: none;
  }
`
const RedDotStyle = styled(RedDot)`
  margin-left: -10px;
  margin-right: 10px;
`
const EnvelopeClosedIconStyle = styled(EnvelopeClosedIcon)`
  width: 40px;
  height: 20px;
`
const TrashIconStyle = styled(TrashIcon)`
  width: 45px;
  height: 23px;
`
const HorizontalLine = styled.hr`
  color: ${Colors.secondaryGrey};
  padding-bottom: 15px;
  margin: 0px;
  opacity: unset;
  margin-left: 100px;
  margin-right: 100px;
  ${Responsive.mobile} {
    margin-left: 30px;
    margin-right: 30px;
    /* margin-top: 20px; */
  }
`
const Filter = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;

  /* open filter button */
  button {
    display: flex;
    align-items: center;
    border: 1px solid ${Colors.primaryBlack};
    border-radius: 4px;
    background-color: transparent;
    height: 48px;
    padding: 0px 25px;
    /* open filter button icon */
    svg {
      height: 10px;
      margin-left: 10px;
    }
  }
`
const ScreenTitle = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
`
const Wrapper = styled.div`
  margin-top: 20px;
  overflow: hidden;
`
const DropdownWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 3rem 3rem;
  padding: 30px 60px 20px 60px;
  background-color: white;
  margin-bottom: 30px;
  ${Responsive.laptop} {
    gap: 2rem 2rem;
  }
  ${Responsive.tablet} {
    gap: 2rem 2rem;
  }
  ${Responsive.mobile} {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 0rem 2rem;
    display: none;
  }
`
const TitleSection = styled.div`
  display: flex;
  height: 20px;
  padding-top: 40px;
  margin-bottom: 20px;
  width: 100%;
  margin-left: 6%;

  ${Responsive.laptop} {
    margin-left: 10%;
  }
  ${Responsive.mobile} {
    display: none;
  }
`
const Title = styled.div`
  font-size: 14px;
  color: ${Colors.primaryGrey};
  user-select: none;

  &:nth-child(1) {
    width: 10%;
    text-align: center;
  }
  &:nth-child(2) {
    width: 47%;
    text-align: center;
  }
  &:nth-child(3) {
    width: 4%;
    text-align: center;
  }
  &:nth-child(4) {
    width: 17%;
    text-align: right;
  }
`
export default NotificationList
